import React from "react";
import AppointmentBtn from "../components/AppointmentBtn";
import "../Styles/DrCard.css";

const DrCard = ({ name, image, designation, speciality, description }) => {
  return (
    <div className="dr-card">
      <div className="image-container">
        <img src={image} alt={name} className="dr-image" />
      </div>

      <div className="dr-info">
        <h2 className="dr-name">{name}</h2>

        {/* Main title (outside brackets) */}
        <p className="dr-designation">{designation}</p>

        {/* Optional speciality (only if exists) */}
        {speciality && <p className="dr-speciality">({speciality})</p>}

        <p className="dr-description">{description}</p>

        <AppointmentBtn />
      </div>
    </div>
  );
};

export default DrCard;
